export class PublicFeedback {
    public trackingId: string;
    public source: string;
    public version: string;
    public textRaw: string;
    public text: string;
    public user: string;
    public sentiment: number;
    public culture: string;
    public uiculture: string;
    public userType: string;
    public correlationIdentity: string;
    public internalVotes: string;
    public tags: FeedbackTag[];
    public userResourceRequest: ExternalFileResourceRequest[];
    public externalVotes: number;
    public title: string;
    public customerChosenArea: string;
    public workaroundFound: WorkaroundFound;
    public watsonEntries: FeedbackWatsonEntry[];
    public dotNetEntries: FeedbackDotNetEntry[];
    public type: CommentType;
    public parentId: number;
}

export class FeedbackTag {
    public type: string;
    public value: string | null;
}

export class FeedbackDotNetEntry {
    public eventTime: string;
    public eventId: string;
    public data: string;
}

export class FeedbackWatsonEntry {
    public eventTime: number;
    public faultBucket: string;
    public hashedBucket: string;
    public watsonReportId: string;
    public eventName: string;
    public cabId: string;
    public applicationName: string;
    public applicationVersion: string;
    public faultingModule: string;
    public faultModuleVersion: string;
}

export class ExternalFileResourceRequest {
    public id: string;
    public name: string;
    public mimeType: string;
    public size: number;
    public hash: string;
    public isExternal: boolean = false;
    public location: string | null = null;
}

export enum WorkaroundFound {
    Unknown = 0,
    Yes = 1,
    No = 2,
}

/// <summary>
/// As of 1/25/2016 this type exists in the Comments table in the SQL type as an integer in the Type column. Any numbers set here should match up there.
/// </summary>
export enum CommentType {
    /// <summary>
    /// This is what a customer views as a feedback item with a textual write-up.
    /// </summary>
    Issue = 0,

    /// <summary>
    /// Group is an internal construct for a grouping of feedback. Feedback of this type should not be submitted publically
    /// </summary>
    Group = 1,

    /// <summary>
    /// A vote on an Issue. It is otherwise submitted the same as an issue so tags and everything can be submitted with the feedback similar to a new issue so the reporting of a vote can be full fidelity to an issue.
    /// </summary>
    Vote = 2,

    /// <summary>
    /// A suggestion/idea/feature
    /// </summary>
    Suggestion = 3,
}
